import CMS from 'netlify-cms-app'
import uploadcare from 'netlify-cms-media-library-uploadcare'
import cloudinary from 'netlify-cms-media-library-cloudinary'
import './cms-utils'

import AboutPagePreview from './preview-templates/AboutPagePreview'
import EventsPagePreview from './preview-templates/EventsPagePreview'
import IndexPagePreview from './preview-templates/IndexPagePreview'
import SermonsPagePreview from './preview-templates/SermonsPagePreview'
import MinistriesPagePreview from './preview-templates/MinistriesPagePreview'
import GivingPagePreview from './preview-templates/GivingPagePreview'
import ContactPagePreview from './preview-templates/ContactPagePreview'

CMS.registerMediaLibrary(uploadcare)
CMS.registerMediaLibrary(cloudinary)

CMS.registerPreviewTemplate('index', IndexPagePreview)
CMS.registerPreviewTemplate('about', AboutPagePreview)
CMS.registerPreviewTemplate('events', EventsPagePreview)
CMS.registerPreviewTemplate('sermons', SermonsPagePreview)
CMS.registerPreviewTemplate('ministries', MinistriesPagePreview)
CMS.registerPreviewTemplate('giving', GivingPagePreview)
CMS.registerPreviewTemplate('contact', ContactPagePreview)
